
<template>
  <div ref="smallPopup" id="sidebarpopup" class="popup overlay smallerpopup"
       data-model="">
    <div ref="popup_wrapper__smaller" class="popup_wrapper popup_wrapper__smaller">
               <span @click="closeOverlay" class="popup_closepopup closeoverlay">
<svg xmlns="http://www.w3.org/2000/svg" width="22.945" height="22.945" viewBox="0 0 22.945 22.945">
  <g id="Gruppe_7895" data-name="Gruppe 7895" transform="translate(1.414 1.414)">
    <line id="Linie_4" data-name="Linie 4" x2="20.117" y2="20.117" transform="translate(0 0)" fill="none" stroke="#fff"
          stroke-linecap="round" stroke-width="2"/>
    <line id="Linie_5" data-name="Linie 5" x2="20.117" y2="20.117" transform="translate(20.117 0) rotate(90)"
          fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2"/>
  </g>
</svg>
</span>
      <span @click="nextStep('launchTimeStep1')" class="popup_prevstep prevstep">
        <img style="transform: scaleX(-1);" src="@/assets/img/arrow-right.svg">
      </span>
      <div class="popup_content popup_content_right">
        <div v-show="showVideo" id="fullscreenvideo">

          <video controlsList="nodownload" ref="videoElement" @ended="videoEnded" :muted="isVolumeMuted" controls playsinline>
            <source v-if="videoData === 'curry'" :src="curryWebmSrc" type="video/webm">
            <source v-if="videoData === 'curry'" :src="curryMp4Src" type="video/mp4">
            <source v-if="videoData === 'sushi'" :src="sushiWebmSrc" type="video/webm">
            <source v-if="videoData === 'sushi'" :src="sushiMp4Src" type="video/mp4">
            <source v-if="videoData === 'spargel'" :src="spargelWebmSrc" type="video/webm">
            <source v-if="videoData === 'spargel'" :src="spargelMp4Src" type="video/mp4">
          </video>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useMediaStore } from '@/globalStorage';
export default {
  name:'LaunchTimeStep2',
  props: {
    formData: {
      type: Object,
      required: true,
    },
    videoData: {
      type: String,
      default: "none",
    },
    isVolumeMuted: {},
  },
  watch: {
    videoData() {

    },
  },
  data() {
    return {
      showVideo: false,
      mediaStore: useMediaStore()
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    curryWebmSrc() {
      return require(`@/assets/video/webspecial_food_curry_${this.locale}.webm`);
    },
    curryMp4Src() {
      return require(`@/assets/video/webspecial_food_curry_${this.locale}.mp4`);
    },
    sushiWebmSrc() {
      return require(`@/assets/video/webspecial_food_sushi_${this.locale}.webm`);
    },
    sushiMp4Src() {
      return require(`@/assets/video/webspecial_food_sushi_${this.locale}.mp4`);
    },
    spargelWebmSrc() {
      return require(`@/assets/video/webspecial_food_spargel_${this.locale}.webm`);
    },
    spargelMp4Src() {
      return require(`@/assets/video/webspecial_food_spargel_${this.locale}.mp4`);
    }
  },
  mounted() {
    this.initView();

  },
  beforeMount() {
    this.$emit('goBack','launchTimeStep1');
  },
  methods: {
    initView() {
      this.showVideo = true; // Video-Container einblenden
      this.$refs.videoElement.play(); // Video abspielen
      this.playVideo()
    },
    playVideo() {
      this.mediaStore.playVideo();
    },
    stopVideo() {
      this.mediaStore.stopVideo();
    },
    videoEnded() {
      this.stopVideo();
      this.$emit('nextStep','outro');
    },
    closeOverlay() {
      this.$emit('closeOverlay')
    },
    nextStep(data) {
      this.$emit('nextStep',data)
    }

  },
};
</script>
<style scoped lang="scss">
$yellow: #FDBE1F;
$mainblue: #015672;
.popup_prevstep {
  background: $yellow;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  position: absolute;
  left: 35px;
  top: 35px;
  border-radius: 10px;
  transition: 0.3s;
  box-sizing: border-box;
  border: 3px solid $yellow;
  z-index: 2;

  @media screen and (max-width: 640px) {
    right: 15px;
    left:15px;
    width: 40px;
    height: 40px;
    top: 15px;
  }
  &:hover {
    background:#ffffff;
    cursor:pointer;
  }
}
.closeoverlay {
  padding: 10px;
  background: $mainblue;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  position: absolute;
  right: 35px;
  top: 35px;
  border-radius: 10px;
  transition: 0.3s;
  box-sizing: border-box;
  z-index: 2;

  svg {
    width: 80%;
    height: auto;
  }

  &:hover {
    cursor: pointer;
    background: $yellow;
  }

  @media screen and (max-width: 768px) {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 35px;
    top: 26px;
  }
  @media screen and (max-width: 640px) {
    right: 15px;
    top: 15px;
  }
}

.popup_wrapper__smaller:has(video) {
  padding: 5px !important;
  @media screen and (max-width:640px) {
    padding-top:70px !important;
  }
}

#fullscreenvideo {
  display:block;
  position:relative;
  width:100%;
  height:auto;
  z-index:1;
  overflow:hidden;
  border-radius:20px;
  video {
    object-position: center;
    height:auto;
    width:auto;
    max-height:70vh;
    max-width: 100%;
    min-height:70vh;
    display:block;
    object-fit: contain;

    @media screen and (max-width: 1366px) {
      min-height:1px;
    }
    @media screen and (max-width: 1024px) {
      width:100vw;
    }
  }
}
</style>
